export const OPPORTUNITIES_FETCH_SUCCESS = 'OPPORTUNITIES_FETCH_SUCCESS';
export const OPPORTUNITIES_FETCH_ERROR = 'OPPORTUNITIES_FETCH_ERROR';
export const UPDATE_OPPORTUNITIES_CURRENT_PAGE = 'UPDATE_OPPORTUNITIES_CURRENT_PAGE';
export const UPDATE_OPPORTUNITIES_TOTAL_PAGES = 'UPDATE_OPPORTUNITIES_TOTAL_PAGES';
export const UPDATE_OPPORTUNITIES_TOTAL_COUNT = 'UPDATE_OPPORTUNITIES_TOTAL_COUNT';



// WEBPACK FOOTER //
// ./src/features/projectFinder/actionTypes.js